﻿import React, { CSSProperties, useState } from 'react';
import { hasPermission } from '@app/helpers/permissions';
import {
    FormatText,
    FormSelect,
    FormSubmitButton,
    MasterDetailForm,
    usePromise,
    Widget,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';

import { GetQaqc, UpdateQaqc } from '@app/api/configuracoes';
import { CSSProp } from 'styled-components';

const DefinicaoDeComprador = () => {

    const [onupdate, setOnupdate] = useState(false);

    const [dadosQaqc] = usePromise(async () => await GetQaqc(), [onupdate], {});
    const update = values => {
        UpdateQaqc(values).then(data => {
            if (data.valid) {
                setOnupdate(!onupdate);
            }
        });
    };

    const roundBorders: CSSProperties = {
        borderRadius: '3px',
    };

    const invisible: CSSProperties = {
        display: 'none',
    };



    const { Panel } = Collapse;
    return (
        <Collapse style={roundBorders} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel style={roundBorders} key="definirCompradorResponsavel" header="DEFINIR COMPRADOR RESPONSÁVEL">
                <MasterDetailForm
                    initialValues={dadosQaqc}
                    onSubmit={update} >
                    <Widget
                        actions={[
                            hasPermission(['CONFIGURACAO_QAQC_EDITAR']) && (
                                <FormSubmitButton icon="ui-save" type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>
                            ),
                        ]}>
                        <FormSelect label="Descrição da Minuta" name="descricaoDaMinuta" span={6} />
                        <FormSelect name="empty" style={invisible} span={9}/>
                        <FormSelect label="Responsável" name="Responsavel" span={6} />
                    </Widget>
                </MasterDetailForm>
            </Panel>
        </Collapse>
    );

};


export default DefinicaoDeComprador;